/**
 * Route for `custom-exchange-rate-per-invoice`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomExchangeRatePerInvoicePage } from "../features/custom-exchange-rate-per-invoice/CustomExchangeRatePerInvoicePage";

export const customExchangeRatePerInvoiceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-exchange-rate-per-invoice",
	component: CustomExchangeRatePerInvoicePage,
});

export default customExchangeRatePerInvoiceRoute;
